module.exports = __webpack_public_path__ + "static/media/level-ten.a9f8bd38.svg";